// jQuery wrapper
(function ($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function () {

		$('body').addClass('active');


		// WOW.js for animations
		new WOW().init();


		// Pages with alt. headers
		if ($('body').hasClass('page-template-page-clinic') || $('body').hasClass('page-template-page-referrals-php') || $('body').hasClass('page-template-page-policies-php') || $('body').hasClass('page-template-page-landing-php')) {
			$('#site-header').addClass('dark-blue-header');
		}
		if ($('body').hasClass('single-post') || $('body').hasClass('blog')) {
			$('#site-header').addClass('yellow-header');
		}

		if ($('body').hasClass('single-team_member') || $('body').hasClass('page-template-page-team-php')) {
			$('#site-header').addClass('dark-blue-bg');
		}


		// Header bar scrolled
		scrollbarState();


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - headerHeight;
			// var scrollPosition = $(target).offset().top;

			$('html').animate({
				scrollTop: scrollPosition
			}, 1000);
		});


		// Accordion list (FAQs / Features)
		if ($('.accordion').length > 0) {
			$('.accordion .answer:not(.active)').hide();

			var allPanels = $('.accordion .answer');

			$('.accordion .question').click(function () {
				var target = $(this).data('target');

				// console.log(targetParent);

				if ($(target).hasClass('active')) {
					$(this).removeClass('current');
					$('.accordion-row').removeClass('open');
					$(target).removeClass('active').slideUp(250);
				} else {
					$('.accordion .question').removeClass('current');
					$(allPanels).removeClass('active').slideUp(250);
					$('.accordion-row').removeClass('open');
					$(this).closest('.accordion-row').addClass('open');
					$(this).addClass('current');
					$(target).addClass('active').slideDown(250);
				}

				// Prevent default 'link' behaviour
				return false;
			});
		}


		// Menu - Hamburger
		$('.hamburger').click(function () {
			var target = $(this).data('target');

			if ($('.hamburger').hasClass('is-active')) {
				$('.hamburger').removeClass('is-active');
				$(target).removeClass('active');
				$('body').removeClass('menu-open child-menu-open');

				// Close active submenus
				$('body').removeClass('sub-menu-open').removeClass('sub-menu-mob-open');
				$('#main-menu-sub').removeClass('open');
				$('#main-menu-child').removeClass('open');
				$('.sub-menu').removeClass('show animated fadeIn current');
				$('.child-menu').removeClass('show animated fadeIn current');

				$('.hasSub .nav-link').removeClass('active');
			} else {
				$('.hamburger').addClass('is-active');

				$(target).toggleClass('active');
				$('body').addClass('menu-open');
			}
		});


		// Dropkick - custom dropdown/select in Forms
		if ($('.form-wrap select').length > 0) {
			$('.form-wrap select').dropkick({
				mobile: true
			});
		}

		// Dropkick - custom dropdown/select on News Filter
		if ($('#filter select').length > 0) {
			$('#filter select').dropkick({
				mobile: true
			});
		}


		// Form privacy pop-up
		if ($('.privacy-toggle').length > 0) {
			$('.privacy-toggle').click(function () {
				var target = $(this).data('target');
				$(target).modal('toggle');

				// Prevent default 'link' behaviour
				return false;
			});
		}


		/***
		 * Menus
		 ***/

		// Main Menu
		$('.main-menu .hasSub > a').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');

			// console.log(target);

			$('.card .hasSub a').not(this).removeClass('active');

			$('.sub .card').removeClass('show animated fadeIn');

			if ($(target).hasClass('current')) {
				$('#main-menu-sub').removeClass('open');
				$('body').removeClass('sub-menu-open');
				$('#main-menu-sub .sub-menu').removeClass('current');
				$(target).removeClass('show animated fadeIn current');
				$(this).removeClass('active');
			} else {
				// Remove active state from open sub-menus & links
				$('#main-menu-sub .sub-menu').removeClass('show animated fadeIn current');
				$('.card .hasSub a').removeClass('active');

				$('#main-menu-sub').addClass('open');
				$('body').addClass('sub-menu-open');
				$(target).addClass('show animated fadeIn current');
				$('#main-menu .hasSub a').removeClass('active');
				$(this).addClass('active');
			}
		});
		// Main Menu - close sub-menu
		$('.close-sub').click(function () {
			event.preventDefault();

			var target = $(this).data('target');
			$('.nav-link.active').removeClass('active');
			$('body').removeClass('sub-menu-open').removeClass('sub-menu-mob-open');
			$('#main-menu-sub').removeClass('open');

			$(target).addClass('fadeOut');
			// setTimeout(function(){
			$(target).removeClass('fadeOut current fadeIn show animated');
			// }, 0);
		});

		// Main Menu - Level 2
		$('.main-menu .hasChild > a').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');

			// console.log(target);

			$('.main-menu .hasChild a').not(this).removeClass('active');

			// $('.child .card').removeClass('show animated fadeIn');

			if ($(target).hasClass('current')) {
				$('#main-menu-child').removeClass('open');
				$('body').removeClass('child-menu-open');
				$('#main-menu-child .child-menu').removeClass('current');
				$(target).removeClass('show animated fadeIn current');
				$(this).removeClass('active');
			} else {
				// Remove active state from open child-menus & links
				$('#main-menu-child .child-menu').removeClass('show animated fadeIn current');
				$('.main-menu .hasChild a').removeClass('active');

				$('#main-menu-child').addClass('open');
				$('body').addClass('child-menu-open');
				$(target).addClass('show animated fadeIn current');
				$('#main-menu .hasChild a').removeClass('active');
				$(this).addClass('active');
			}
		});
		// Main Menu - Close Child 
		$('.close-child').click(function () {
			event.preventDefault();

			var target = $(this).data('target');
			$('.nav-link.active').removeClass('active');
			$('body').removeClass('child-menu-open').removeClass('child-menu-mob-open');
			$('#main-menu-child').removeClass('open');

			$(target).addClass('fadeOut');
			// setTimeout(function(){
			$(target).removeClass('fadeOut current fadeIn show animated');
			// }, 0);
		});

		// Dropdowns - Don't close on link click
		$('.dropdown-menu .dropdown-item').click(function (e) {
			console.log('dropdown link clicked');
			e.stopPropagation();
		});


		/*
		// Featured Treatment menu trigger
		$('#featured-treatments .menu-trigger').click(function(event) {
			event.preventDefault();
			
			var target = $(this).data('target');
			$('#site-header .hamburger').addClass('is-active');
			$('#menu-outer').addClass('active');

			$('#main-menu-sub').addClass('open');
			$('#treatment-submenu.sub-menu').addClass('show animated fadeIn current')

			$('#main-menu-child').addClass('open');
			$('body').addClass('menu-open sub-menu-open child-menu-open');
			$(target).addClass('show animated fadeIn current');
		});
		*/

		// Related Treatments / Conditions menu trigger
		$('#related-treatments .menu-trigger').click(function (event) {
			event.preventDefault();

			var target = $(this).data('target');
			$('#site-header .hamburger').addClass('is-active');
			$('#menu-outer').addClass('active');

			$('#main-menu-sub').addClass('open');
			$('#treatment-submenu.sub-menu').addClass('show animated fadeIn current')

			$('body').addClass('menu-open sub-menu-open');
			$(target).addClass('show animated fadeIn current');
		});
		$('#related-conditions .menu-trigger').click(function (event) {
			event.preventDefault();

			var target = $(this).data('target');
			$('#site-header .hamburger').addClass('is-active');
			$('#menu-outer').addClass('active');

			$('#main-menu-sub').addClass('open');
			$('#condition-submenu.sub-menu').addClass('show animated fadeIn current')

			$('body').addClass('menu-open sub-menu-open');
			$(target).addClass('show animated fadeIn current');
		});


		/***
		 * Carousels
		 ***/

		// Homepage - Hero header carousel
		if ($('.hero-carousel').length > 0) {
			$('.hero-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 6000,
				speed: 5000,
				fade: true,
				arrows: false,
				infinite: true,
				centerMode: false,
				pauseOnHover: false,
			});
		}

		// Homepage - Awards carousel
		if ($('.awards-carousel').length > 0) {
			$('.awards-carousel').slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 6000,
				fade: false,
				dots: false,
				arrows: false,
				infinite: true,
				centerMode: false,
			});
		}

		// Homepage - Treatment carousel
		if ($('.treatment-carousel').length > 0) {
			$('.treatment-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.treatment-controls .treatment-prev'),
				nextArrow: $('.treatment-controls .treatment-next'),
			});
		}

		// In The Media / Publications
		if ($('.media-carousel').length > 0) {
			$('.media-carousel').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				speed: 5000,
				cssEase: 'linear',
				arrows: false,
				infinite: true,
				centerMode: false,
				pauseOnHover: false,

				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
						}
					},
				]
			});
		}

		// Homepage - Facilities carousel
		if ($('.facilities-carousel').length > 0) {
			$('.facilities-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 4000,
				fade: true,
				dots: false,
				arrows: false,
				infinite: true,
				centerMode: false,
			});
		}

		// Testimonial carousel
		if ($('.testimonial-carousel').length > 0) {
			$('.testimonial-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				fade: true,
				dots: true,
				arrows: false,
				infinite: true,
				centerMode: false,
				draggable: false,
				swipe: true,
			});
		}

		// Video carousel
		if ($('.video-carousel').length > 0) {
			$('.video-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				infinite: true,
				centerMode: false,
				draggable: false,
				swipe: true,
				prevArrow: $('.video-prev'),
				nextArrow: $('.video-next')
			});
		}


		// Patient Journey carousel
		if ($('.journey-carousel').length > 0) {
			$('.journey-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 4000,
				fade: true,
				dots: true,
				arrows: false,
				infinite: true,
				centerMode: false,
			});
		}

		// Before / After slider
		$('.ba-slider').each(function () {
			var cur = $(this);
			// Adjust the slider
			var width = cur.width() + 'px';
			cur.find('.resize img').css('width', width);
			// Bind dragging events
			drags(cur.find('.handle'), cur.find('.resize'), cur);
		});


		// Referral Form
		if ($('.referral-form.custom').length > 0) {
			$('select[name="treatment_choice"]').on('change', function () {
				var optionSelected = $("option:selected", this);
				var valueSelected = this.value;
				console.log(valueSelected);
				$('#input_3_1').val(valueSelected);
			});

			$('input[name="practice_name"]').keyup(function () {
				$('#input_3_3').val($(this).val());
			});
			$('input[name="professional_name"]').keyup(function () {
				$('#input_3_4').val($(this).val());
			});
			$('input[name="mobile_practice"]').keyup(function () {
				$('#input_3_5').val($(this).val());
			});

			$('input[name="dob_practice"]').keyup(function () {
				$('#input_3_6').val($(this).val());
			});
			$('input[name="gmc_practice"]').keyup(function () {
				$('#input_3_7').val($(this).val());
			});

			$('input[name="telephone_practice"]').keyup(function () {
				$('#input_3_8').val($(this).val());
			});


			// Address
			$('textarea[name="address_practice"]').keyup(function () {
				$('#input_3_9').val($(this).val());
			});

			$('input[name="postcode_practice"]').keyup(function () {
				$('#input_3_10').val($(this).val());
			});
			$('input[name="email_practice"]').keyup(function () {
				$('#input_3_11').val($(this).val());
			});

			// Validating required fields
			$('input[name="practice_name"], input[name="professional_name"], input[name="gmc_practice"], input[name="telephone_practice"], textarea[name="address_practice"], input[name="postcode_practice"], input[name="email_practice"]').blur(function () {
				var check = $(this).val();
				if (check == '') {
					$('#gform_submit_button_3').addClass('disabled');
				} else {
					$('#gform_submit_button_3').removeClass('disabled');
				}
			});

			// Error Message 
			if ($('.gform_submission_error').length > 0) {
				$('.referral-form.custom').prepend(
					'<div><h2 class="fs32"><span class="gform-icon gform-icon--close"></span>There was a problem with your submission. Please review the form and try again.</h2></div>'
				);
			}
		}


		/*
		// Set Cookie function
		function createCookie(name, value, days) {
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				var expires = "; expires=" + date.toGMTString();
			} else var expires = "";
			document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
		}
		// Privacy Policy Cookies   
		function cookiesPolicyBar(){
			// Check cookie 
			if ($.cookie('aboodCookiePolicy') != "accepted") $('#cookie-banner').fadeIn(); 

			//Assign cookie on click
			$('#cookie-banner a, #cookie-banner button').on('click',function(){
				createCookie("aboodCookiePolicy", "accepted", 90); // Cookie expires in 90 days
				$('#cookie-banner').fadeOut();
			});
		}           
		// Run cookie policy function
		cookiesPolicyBar();
		*/

	}); // End Document Ready

	// On load
	$(window).on('load', function () {

		// Carousel Equal Heights
		carouselEqualHeights();

	});


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {

		// Carousel Equal Heights
		carouselEqualHeights();

		// Before / After slider - Update sliders on resize.
		$('.ba-slider').each(function () {
			var cur = $(this);
			var width = cur.width() + 'px';
			cur.find('.resize img').css('width', width);
		});

	});


	// Carousel - Equal heights
	function carouselEqualHeights() {
		$('.carousel.equal').on('setPosition', function () {
			$(this).find('.slick-slide').height('auto');
			var slickTrack = $(this).find('.slick-track');
			var slickTrackHeight = $(slickTrack).height();
			$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
		});
	}


	// Header bar scrolled
	function scrollbarState() {
		var navHeight = $('#site-header').outerHeight();

		if ($(document).scrollTop() > navHeight) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	// Before / After drag function
	function drags(dragElement, resizeElement, container) {

		// Initialize the dragging event on mousedown.
		dragElement.on('mousedown touchstart', function (e) {

			dragElement.addClass('draggable');
			resizeElement.addClass('resizable');

			// Check if it's a mouse or touch event and pass along the correct value
			var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

			// Get the initial position
			var dragWidth = dragElement.outerWidth(),
				posX = dragElement.offset().left + dragWidth - startX,
				containerOffset = container.offset().left,
				containerWidth = container.outerWidth();

			// Set limits
			var minLeft = containerOffset + 10;
			var maxLeft = containerOffset + containerWidth - dragWidth - 10;

			// Calculate the dragging distance on mousemove.
			dragElement.parents().on("mousemove touchmove", function (e) {

				// Check if it's a mouse or touch event and pass along the correct value
				var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

				var leftValue = moveX + posX - dragWidth;

				// Prevent going off limits
				if (leftValue < minLeft) {
					leftValue = minLeft;
				} else if (leftValue > maxLeft) {
					leftValue = maxLeft;
				}

				// Translate the handle's left value to masked divs width.
				var widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

				// Set the new values for the slider and the handle. 
				// Bind mouseup events to stop dragging.
				$('.draggable').css('left', widthValue).on('mouseup touchend touchcancel', function () {
					$(this).removeClass('draggable');
					resizeElement.removeClass('resizable');
				});
				$('.resizable').css('width', widthValue);

			}).on('mouseup touchend touchcancel', function () {

				dragElement.removeClass('draggable');
				resizeElement.removeClass('resizable');

			});
			e.preventDefault();

		}).on('mouseup touchend touchcancel', function (e) {

			dragElement.removeClass('draggable');
			resizeElement.removeClass('resizable');

		});
	}

	// end jQuery wrapper
})(jQuery);